import { Button, Col, Form, Row } from "antd";
import { Spinal } from "components/spinal/Spinal";
import { PercelenModel } from "pages/bodem-en-gewas/percelen-old/models/percelenMock";
import React, { FC } from "react";
import { CardTable } from "../../../../components/card-table";
import { achtergrondInfo } from "../../bodem-overig/info/achtergrondInfo";
import { PerceelRow } from "./components/perceelRow"; // const formValuesChange = (() => {

const info = (
  fosfaattoestandCategorieen: PercelenModel["fosfaattoestandCategorieen"] = []
) => (
  <>
    <div>
      <p>
        Bij dit onderdeel kunt u de benodigde gegevens voor gewaspercelen
        handmatig invoeren (lege regel toevoegen). En indien gewenst weer
        verwijderen.
      </p>
      <p>
        TIP: Indien u volledig handmatig werkt kunt u hier ook de gewaspercelen
        met hetzelfde gewas, grondsoort en grondwatertrap als één perceel
        opgeven, met totale oppervlakte en gewogen gehalten P-Al en Pw, dat kan
        werk besparen. U kunt ook onder het menu bedrijf/algemeen er voor kiezen
        om de optie koppeltool niet te gebruiken. Dan kunt u de benodigde
        samenvatting van de gegevens in het volgende blok handmatig invoeren, de
        standaard werkwijze t/m 2018.
      </p>
      {achtergrondInfo(fosfaattoestandCategorieen)}
    </div>
  </>
);
interface HandmatigeGewasPercelenProps {
  isKlwReadOnly: boolean;
  isLoading: boolean;
  klwJaar: number;
  gebruikKoppeltool: boolean;
  gebruikKoppeltoolKoolstofBodem: boolean;
}

export const HandmatigeGewasPercelen: FC<HandmatigeGewasPercelenProps> = ({
  isKlwReadOnly,
  isLoading,
  klwJaar,
  gebruikKoppeltool,
  gebruikKoppeltoolKoolstofBodem,
}) => {
  return (
    <>
      <CardTable>
        <CardTable.Header>
          <Form.Item
            noStyle
            shouldUpdate={(prev, cur) => {
              return (
                prev.fosfaattoestandCategorieen !==
                cur.fosfaattoestandCategorieen
              );
            }}
          >
            {({ getFieldValue }) => {
              const fosfaattoestandCategorieen = getFieldValue([
                "fosfaattoestandCategorieen",
              ]);
              return (
                <CardTable.Header.Title
                  infoContent={info(fosfaattoestandCategorieen)}
                >
                  Handmatige gewaspercelen
                </CardTable.Header.Title>
              );
            }}
          </Form.Item>
          <CardTable.Header.ColumnTitles>
            <Row gutter={12}>
              <Col span={3}>Perceelaanduiding</Col>
              <Col span={3} style={{ paddingLeft: 16 }} className="text-left">
                Gewascode + gewas
              </Col>
              <Col span={2} style={{ paddingLeft: 16 }} className="text -left">
                Grondsoort
              </Col>
              {gebruikKoppeltool && (
                <Col span={2} style={{ paddingLeft: 16 }} className="text-left">
                  GWT
                </Col>
              )}
              <Col
                span={
                  !gebruikKoppeltool && gebruikKoppeltoolKoolstofBodem ? 3 : 2
                }
              >
                Oppervlakte
                <CardTable.ColumnUnit>[ha]</CardTable.ColumnUnit>
              </Col>
              {gebruikKoppeltoolKoolstofBodem && (
                <>
                  <Col span={!gebruikKoppeltool ? 3 : 2}>
                    SOC<CardTable.ColumnUnit>[%]</CardTable.ColumnUnit>
                  </Col>
                  <Col span={!gebruikKoppeltool ? 3 : 1}>
                    o.s.<CardTable.ColumnUnit>[%]</CardTable.ColumnUnit>
                  </Col>
                  <Col span={!gebruikKoppeltool ? 3 : 1}>
                    Lutum<CardTable.ColumnUnit>[%]</CardTable.ColumnUnit>
                  </Col>
                  <Col span={!gebruikKoppeltool ? 3 : 1}>C/N</Col>
                </>
              )}
              {gebruikKoppeltool && (
                <>
                  <Col span={!gebruikKoppeltoolKoolstofBodem ? 2 : 1}>P-Al</Col>
                  <Col span={!gebruikKoppeltoolKoolstofBodem ? 2 : 1}>Pw</Col>
                  <Col span={!gebruikKoppeltoolKoolstofBodem ? 2 : 1}>
                    P-PAE
                  </Col>
                  <Col className="text-right" span={2}>
                    Fosfaatklasse bepaling
                  </Col>
                  <Col span={1} className="text-right">
                    Fixerend
                  </Col>
                </>
              )}
            </Row>
          </CardTable.Header.ColumnTitles>
        </CardTable.Header>
        <CardTable.Body>
          <Form.Item
            noStyle
            shouldUpdate={(prev, cur) => {
              return (
                prev.gewascodes !== cur.gewascodes ||
                prev.fosfaattoestandCategorieen !==
                  cur.fosfaattoestandCategorieen
              );
            }}
          >
            {({ getFieldValue }) => {
              const gewascodes: PercelenModel["gewascodes"] = getFieldValue([
                "gewascodes",
              ]);
              const fosfaattoestandCategorieen: PercelenModel["fosfaattoestandCategorieen"] =
                getFieldValue(["fosfaattoestandCategorieen"]);
              return (
                <Spinal
                  initializing={!fosfaattoestandCategorieen || !gewascodes}
                  loading={isLoading}
                >
                  <Form.List name={["gewaspercelen"]}>
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map((_, index) => (
                          <PerceelRow
                            key={index}
                            isKlwReadOnly={isKlwReadOnly}
                            gewascodes={gewascodes}
                            index={index}
                            remove={remove}
                            klwJaar={klwJaar}
                            gebruikKoppeltool={gebruikKoppeltool}
                            gebruikKoppeltoolKoolstofBodem={
                              gebruikKoppeltoolKoolstofBodem
                            }
                          />
                        ))}
                        <Button
                          disabled={isKlwReadOnly}
                          onClick={() =>
                            add({
                              fixerend: true,
                              handmatig: true,
                              fosfaatklasseBepalingMethode: null,
                              perceelId: 0,
                              gewasPerceelId: "",
                              gewascodeId: 1534,
                            })
                          }
                          type="primary"
                          shape="round"
                          size="small"
                          style={{ marginTop: 5 }}
                        >
                          Perceel toevoegen
                        </Button>
                      </>
                    )}
                  </Form.List>
                </Spinal>
              );
            }}
          </Form.Item>
        </CardTable.Body>
      </CardTable>
    </>
  );
};
